module.exports = __webpack_public_path__ + "img/default.8e6e21ce.png";